import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import useNavProps from '../../hooks/useNavProps';
import CompetitionToolbar from './CompetitionToolbar';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import CompetitionJobCalendarComponent from '../../components/competition/CompetitionJobCalendarComponent';

const CompetitionCalendar = () => {
    const [competition, setCompetition] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    const { competitionIdParam } = useParams();

    const { setNavPropsValue } = useNavProps();

    useEffect(() => {
        setIsLoading(true);
        const getCompetition = async () => {
            await competitionService.getCompetition(competitionIdParam)
                .then(async (competitionData) => {
                    // console.log(competitionData);
                    setCompetition(competitionData);

                    setNavPropsValue('competition-job', competitionData.id, competitionData.name)

                    setIsLoading(false);
                })
                .catch((error) => toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getCompetition();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService, competitionIdParam]);

    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className="grid h-full">
                    <div className="col-12">
                        <div className="card h-full">
                            <CompetitionToolbar competition={competition} code="CALENDAR" />

                            {CompetitionUtils.isJobCompetition(competition?.type) &&
                                <CompetitionJobCalendarComponent competition={competition} />
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default CompetitionCalendar;
